import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import CustomBreadcrumb from "../../../../components/customBreadcrumb/CustomBreadcrumb";
import CustomRadio from "../../../../components/customRadio/CustomRadio";
import Title from "../../../../components/title/Title";
import AccountFavourites from "./accountFavourites";
import BroadbandFavourites from "./broadbandFavourites";

const AddToFavourites = () => {
  const [selectedRadioIndex, setSelectedRadioIndex] = useState(0);

  return (
    <div className="page-container">
      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          {
            path: "/Settings/AddToFavourite",
            title: "Add to Favourite",
          },
        ]}
      />
      <>
        <Title
          className="text-center font-size-32 mb-3 poppins-semibold"
          color="#1E4894"
        >
          Add to Favourite
        </Title>

        <Row className="justify-content-center mb-3">
          <Col className="col-md-6">
            <CustomRadio
              selectedIndex={selectedRadioIndex}
              onChange={(index: number) => setSelectedRadioIndex(index)}
              items={[
                {
                  label: "Account Number",
                  index: 0,
                },
                {
                  label: "Broadband",
                  index: 1,
                },
              ]}
            />
          </Col>
        </Row>
      </>

      {selectedRadioIndex === 0 ? (
        <AccountFavourites />
      ) : (
        <BroadbandFavourites />
      )}
    </div>
  );
};

export default AddToFavourites;
